import { z } from 'zod/v4';

export const RestoreCompanyParamsSchema = z.object({
  id: z.string().min(1, 'Company ID is required'),
});

export type RestoreCompanyParams = z.infer<typeof RestoreCompanyParamsSchema>;
